export default __webpack_public_path__ + "static/media/rain@2x.8202326a.png";